import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  getCompanySuggestions,
  approveCompanySuggestion,
  rejectCompanySuggestion,
} from "@/services/adminApi";

export function useCompanySuggestions() {
  return useQuery({
    queryKey: ["admin", "company-suggestions"],
    queryFn: getCompanySuggestions,
  });
}

export function useApproveCompanySuggestion() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, country }: { id: string; country?: string }) =>
      approveCompanySuggestion(id, country),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["admin", "company-suggestions"] });
    },
  });
}

export function useRejectCompanySuggestion() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, reason }: { id: string; reason?: string }) =>
      rejectCompanySuggestion(id, reason),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["admin", "company-suggestions"] });
    },
  });
}
